import * as React from 'react'

import { ChevronsDownUpIcon, ChevronsUpDownIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'

interface IProps {
  isExpanded: boolean
  onClick: () => void
  /** Localized accessible name; required so each surface picks the right wording. */
  ariaLabel: string
  /** Optional tooltip text; defaults to `ariaLabel`. */
  title?: string
  /** Button size variant; defaults to the standard icon button. */
  size?: React.ComponentProps<typeof Button>['size']
  className?: string
}

// `aria-pressed` (toggle), not `aria-expanded` (disclosure) — controls many bands.
export const CollapseButton: React.FC<IProps> = ({
  isExpanded,
  onClick,
  ariaLabel,
  title,
  size = 'icon',
  className,
}) => {
  const Icon = isExpanded ? ChevronsDownUpIcon : ChevronsUpDownIcon
  return (
    <Button
      type="button"
      variant="ghost"
      size={size}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-pressed={isExpanded}
      title={title ?? ariaLabel}
      className={className}
    >
      <Icon aria-hidden="true" />
    </Button>
  )
}
